/** Keep behavior aligned with public/forward.js */

const link = process.env.REACT_APP_WEB_APP_LINK;
export const FIND_MOORINGS_BASE = `${link}FindMoorings`;

export function getForwardTargetUrl(pathname) {
  const path = (pathname || "").replace(/\/+$/, "") || "/";
  const m = path.match(/^\/(\d+)$/);
  if (m) return `${FIND_MOORINGS_BASE}/${m[1]}`;
  return FIND_MOORINGS_BASE;
}

/** Redirect only this browsing context (the iframe), never the embedding page. */
export function replaceBrowsingContext(url) {
  if (typeof window === "undefined") return;
  window.location.replace(url);
}
